import { render, staticRenderFns } from "./TaskNotes.vue?vue&type=template&id=671b85bc&scoped=true"
import script from "./TaskNotes.vue?vue&type=script&lang=js"
export * from "./TaskNotes.vue?vue&type=script&lang=js"
import style0 from "./TaskNotes.vue?vue&type=style&index=0&id=671b85bc&prod&scoped=true&lang=css"
import style1 from "./TaskNotes.vue?vue&type=style&index=1&id=671b85bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b85bc",
  null
  
)

export default component.exports